// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { StationData } from '@/lib/types/api/stations-data';

// svgs
import CheckIcon from '@/public/svg/check.svg';

// styles
import styles from './PassportFeatureTable.module.scss';

export interface PassportFeatureTableProps {
  stationData: StationData;
}

export default function PassportFeatureTable(props: PassportFeatureTableProps) {
  const { stationData } = props;

  const { attributes: station_info } = stationData;

  const {
    ga_live_stream_url,
    short_common_name,
  } = station_info;

  interface PassportCheckmarkProps {
    isPassportFeature: boolean;
  }

  const PassportTableCheckmark = (props: PassportCheckmarkProps) => {
    const { isPassportFeature } = props;
    const accessibleText = isPassportFeature ?
      `Included with ${short_common_name} Passport` :
      `Available to everyone`;
    return (
      <td className={styles.passport_feature_table__checkmark} data-sentry-component="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx">
        <CheckIcon data-sentry-element="CheckIcon" data-sentry-source-file="PassportFeatureTable.tsx" />
        <span className="visuallyhidden">{accessibleText}</span>
      </td>
    )
  }

  const PassportTableDash = () => {
    return (
      <td className={styles.passport_feature_table__dash} data-sentry-component="PassportTableDash" data-sentry-source-file="PassportFeatureTable.tsx">
        <span aria-hidden="true">—</span>
        <span className="visuallyhidden">Only available with Passport</span>
      </td>
    )
  }

  return (
    <div className={styles.passport_feature_table__wrapper} data-sentry-component="PassportFeatureTable" data-sentry-source-file="PassportFeatureTable.tsx">
      <table className={styles.passport_feature_table_full}>
        <thead>
          <tr>
            <td></td>
            <th scope="col" className={styles.passport_feature_table__header_cell}>
              <p className={styles.passport_feature_table__header_description_pbs}>
                Without Passport
              </p>
            </th>
            <th scope="col" className={styles.passport_feature_table__header_cell}>
              <p className={styles.passport_feature_table__header_description_passport}>
                With Passport
              </p>
            </th>
          </tr>
        </thead>
        <tbody>

          <tr>
            <th scope="row" className={styles.passport_feature_table__feature}>
              Stream the latest episodes of your favorite shows on PBS.org and the PBS app
            </th>
            <PassportTableCheckmark isPassportFeature={false} data-sentry-element="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx" />
            <PassportTableCheckmark isPassportFeature={true} data-sentry-element="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx" />
          </tr>

          { ga_live_stream_url && (
            <tr>
              <th scope="row" className={styles.passport_feature_table__feature}>
                Enjoy Live TV from {short_common_name}
              </th>
              <PassportTableCheckmark isPassportFeature={false} />
              <PassportTableCheckmark isPassportFeature={true} />
            </tr>
          )}

          <tr>
            <th scope="row" className={styles.passport_feature_table__feature}>
              Catch up on news and public affairs
            </th>
            <PassportTableCheckmark isPassportFeature={false} data-sentry-element="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx" />
            <PassportTableCheckmark isPassportFeature={true} data-sentry-element="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx" />
          </tr>

          <tr>
            <th scope="row" className={styles.passport_feature_table__feature}>
              Get extended access to even more episodes
            </th>
            <PassportTableDash data-sentry-element="PassportTableDash" data-sentry-source-file="PassportFeatureTable.tsx" />
            <PassportTableCheckmark isPassportFeature={true} data-sentry-element="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx" />
          </tr>

          <tr>
            <th scope="row" className={styles.passport_feature_table__feature}>
              Watch full seasons of most popular shows
            </th>
            <PassportTableDash data-sentry-element="PassportTableDash" data-sentry-source-file="PassportFeatureTable.tsx" />
            <PassportTableCheckmark isPassportFeature={true} data-sentry-element="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx" />
          </tr>

          <tr>
            <th scope="row" className={styles.passport_feature_table__feature}>
              Stream early releases and other exclusive content
            </th>
            <PassportTableDash data-sentry-element="PassportTableDash" data-sentry-source-file="PassportFeatureTable.tsx" />
            <PassportTableCheckmark isPassportFeature={true} data-sentry-element="PassportTableCheckmark" data-sentry-source-file="PassportFeatureTable.tsx" />
          </tr>
        </tbody>
      </table>
    </div>
  )
}
